import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import AllSummaryPage from "./AllSummaryPage";
import PaymentPlatformDashboardPage from "./PaymentPlatformDashboardPage";
import { getTenantById } from "./api/tenantApi";

export default function TenantDashboardHome() {
  const { tenantIdp } = useParams();
  const [tenantType, setTenantType] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setTenantType(null);
    setError("");
    getTenantById(tenantIdp)
      .then((result) => {
        if (!active) return;
        const tenant = result?.data || result;
        setTenantType(tenant?.tenantType || "regular");
      })
      .catch((requestError) => {
        if (!active) return;
        setError(requestError?.response?.data?.message || "Could not load this tenant dashboard.");
      });
    return () => {
      active = false;
    };
  }, [tenantIdp]);

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!tenantType) {
    return (
      <Box sx={{ minHeight: 320, display: "grid", placeItems: "center" }}>
        <CircularProgress aria-label="Loading tenant dashboard" />
      </Box>
    );
  }

  return tenantType === "payment_platform" ? (
    <PaymentPlatformDashboardPage />
  ) : (
    <AllSummaryPage adminAction />
  );
}
